function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#000"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-436 -442) translate(436 442)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 6.5
}))));
const SvgUiIconUtility24OtherCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUiIconUtility24OtherCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ui-icon-utility-24-other-circle.b48ce361.svg";
export { ForwardRef as ReactComponent };